import { post, get } from './request';
// 获取评论数量的数据
export const batchQuerySubjectCount = async ids => {
    const res = await post({
        url: '/batchQuerySubjectCount',
        params: {
            ids,
            appId: 'foKBq4TrE8JzKuox',
        },
        config: {
            // eslint-disable-next-line no-undef
            basePath: 'https://picus.ifeng.com/proxy/test-movie-comment',
            headers: {
                commentAppId: 'foKBq4TrE8JzKuox',
            },
        },
    });

    return res;
};
